// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_upload-template_upload-template_module_ts":"f15d938066c38a12","src_app_pages_uploaded-template_uploaded-template_module_ts":"8b6c21ed86034f07","src_app_pages_societies_societies_module_ts":"0ad648724491cb55"}[chunkId] + ".js";
};